var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56088 20.4114C6.18713 20.0359 5.97782 19.5274 5.97897 18.9976L5.98791 16.9985H2.89557L1.80078 13.151L17.1819 4.5L20.6906 16.9857L14.9778 16.9985L14.979 19.0427C14.9768 19.5637 14.7678 20.0626 14.3979 20.4297C14.028 20.7967 13.5275 21.0019 13.0065 21L7.97197 20.9998C7.4422 20.9985 6.93462 20.7869 6.56088 20.4114ZM12.9877 16.9927L7.98997 16.9985L7.97996 19.0045L12.9759 18.9985L12.9877 16.9927ZM22.093 9.24186C22.2305 9.51727 22.3016 9.82103 22.3007 10.1288C22.3036 10.5653 22.163 10.9907 21.9006 11.3395C21.6381 11.6882 21.2684 11.9411 20.8481 12.0593L19.7637 8.23218C20.0587 8.14422 20.3701 8.12649 20.6732 8.18041C20.9762 8.23433 21.2625 8.35841 21.509 8.54271C21.7555 8.72702 21.9555 8.96645 22.093 9.24186Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2b3dd780.svg";
export { ForwardRef as ReactComponent };